import React from "react";
import type { Client, Collab } from "../studio.ts";

export const Headline = () => (
	<p className="nh-headline">
		A <em>better</em>, <em>faster</em>, &amp; <em>nicer</em> creative studio.
	</p>
);

export const CollabLinks = ({ collabs }: { collabs: Collab[] }) => (
	<>
		(collab w/{" "}
		{collabs.map((partner, i) => (
			<React.Fragment key={partner.name}>
				{partner.url ? (
					<a href={partner.url} target="_blank" rel="noreferrer">
						{partner.name}
					</a>
				) : (
					partner.name
				)}
				{i < collabs.length - 1 ? ", " : ""}
			</React.Fragment>
		))}
		)
	</>
);

export const ClientList = ({
	label,
	clients,
	numbered = false,
}: {
	label: string;
	clients: Client[];
	numbered?: boolean;
}) => (
	<div className="nh-clients">
		<p className="nh-label">{label}</p>
		{clients.map(({ name, slug, services, collabs }, index) => (
			<p key={slug} className="nh-client">
				{numbered ? (
					<span className="nh-client-num" aria-hidden="true">
						[{String(index + 1).padStart(2, "0")}]
					</span>
				) : null}
				{name}
				{services.length ? (
					<>
						{" "}
						<span className="nh-client-services">— {services.join(", ")}</span>
					</>
				) : null}
				{collabs.length ? (
					<>
						{" "}
						<span className="nh-client-collab">
							— <CollabLinks collabs={collabs} />
						</span>
					</>
				) : null}
			</p>
		))}
	</div>
);

export const InstagramLink = () => (
	<div>
		<p className="nh-label">Instagram</p>
		<p className="nh-client">
			<a
				href="https://www.instagram.com/wownicehandwriting/"
				target="_blank"
				rel="noreferrer"
			>
				@wownicehandwriting
			</a>
		</p>
	</div>
);

export const FooterNote = () => (
	<div className="nh-footer">
		<p className="nh-italic">New clients accepted by referral only.</p>
		<p>© 2024–{new Date().getFullYear()} Nice Handwriting LLC</p>
	</div>
);
